import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

export const getAgreement = (terrace) => {

  const params = new URLSearchParams(window.location.search);
  const tenant_id = params.get('tenant_id');
  const config = tenant_id ? { headers: { tenantId: tenant_id } } : {};
  return hMacAjax.get(
    baseURL + '/grt-user-center-service/open/privacy/agreement/new/version/info?terrace=' + terrace,
    {},
    config
  );
};
